import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';

// Actions
import { alerts } from 'modules/alerts/actions';
import { actions as modalActions } from 'modules/modals/actions';

// Services
import PurchaseOrder from 'services/data/purchase-order';
import ExpenseBill from 'services/data/expense-bill';

// Components
import EditExpenseBill from './edit-expense-bill';
import AddReturn from './add-return';
import { ExpenseBillRow, ShippingTaxTotalRow, LineItemRow } from './expense-bill-components';


// Component
class ExpenseBillTable extends React.Component {
  static propTypes = {
    expenseBill: PropTypes.object.isRequired,
    currentUser: PropTypes.object,
    purchaseOrder: PropTypes.object.isRequired
  };

  constructor() {
    super();
    this.state = { editing: false, returning: false };

    this.confirmDelete = this.confirmDelete.bind(this);
    this.deleteExpenseBill = this.deleteExpenseBill.bind(this);
  }


  confirmDelete(expenseBillId, purchaseOrderId) {
    modalActions.showDeleteModal({
      onConfirm: () => this.deleteExpenseBill(expenseBillId, purchaseOrderId),
      title: 'Are you sure you want to delete this charge?',
      body: 'All of the line items will show up back on the purchase order.'
    });
  }

  deleteExpenseBill(expenseBillId, purchaseOrderId) {
    return ExpenseBill.delete(expenseBillId)
      .then(() => PurchaseOrder.findOne(purchaseOrderId, PurchaseOrder.defaultQuery))
      .then(this.props.purchaseOrder.update)
      .catch((err) => {
        const xeroErrorMessage = _.get(err, 'data.Elements.DataContractBase.ValidationErrors.ValidationError.Message');

        if (xeroErrorMessage === 'This Bank Transaction cannot be edited as it has been reconciled with a Bank Statement.') {
          return alerts.error({
            title: 'Couldn\'t delete charge. Charge has been reconciled in Xero.',
            subtitle: 'Contact a Praece administrator if you need to delete this charge.'
          });
        }

        alerts.catchError(err);
      });
  }


  render() {
    const { expenseBill, currentUser, purchaseOrder } = this.props;

    if (this.state.editing) {
      return (
        <tbody>
          <tr>
            <td colSpan="6" className="form-container">
              <EditExpenseBill
                afterSubmit={purchaseOrder.update}
                expenseBill={expenseBill}
                cancel={() => this.setState({ editing: false })}
                header="Edit Charge"
                form={`editExpenseBillForm-${expenseBill.id}`}
              />
            </td>
          </tr>
        </tbody>
      );
    }

    return (
      <tbody>
        <ExpenseBillRow
          expenseBill={expenseBill}
          currentUser={currentUser}
          edit={() => this.setState({ editing: true })}
          createReturn={() => this.setState({ returning: true })}
          disableActions={this.state.editing || this.state.returning}
          purchaseOrder={purchaseOrder}
          deleteExpenseBill={this.confirmDelete}
        />
        {_.map(expenseBill.lineItems, (lineItem) =>
          <LineItemRow item={lineItem} key={lineItem.id} />
        )}
        <ShippingTaxTotalRow amount={expenseBill.shipping} description={'Shipping'} />
        <ShippingTaxTotalRow amount={expenseBill.tax} description={'Sales Tax Paid'} />
        <ShippingTaxTotalRow amount={expenseBill.amount} description={'Total'} />

        {this.state.returning &&
          <AddReturn
            cancel={() => this.setState({ returning: false })}
            form={`returnExpenseBillForm-${expenseBill.id}`}
            expenseBill={expenseBill}
            updatePurchaseOrder={purchaseOrder.update}
          />
        }
      </tbody>
    );
  }
}

export default connect((state) => ({ currentUser: state.auth.currentUser }))(ExpenseBillTable);
